import React, { useState } from 'react'
import { Box, Button, Divider, Grid, Pagination, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ScrollBox from '../../../components/ScrollBox';
import SearchTxtField from '../../../components/SearchTxtField';
import BackButton from '../../../components/BackButton';
import BgBoxOld from '../../../components/BgBoxOld';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { getSrchTypeTxt, isNotEmpty } from '../../../utils/format';
import { useEffect } from 'react';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert, notify } from '../../../components/notify';
import { getProdsNotInCatServ } from '../../../services/com-service';
import CustomDropDown from '../../../components/CustomDropDown';
import ProdCardBtn from './ProdCardBtn';
import { AddCircle, RemoveCircle } from '@mui/icons-material';
import route from '../../../utils/Routes';


function AddProdToCompCatalog() {
    const ddArr = [
        { value: "prodName", label: "Name" },
        { value: "amtcProdIdStrg", label: "AMTC Ref PID" }
    ]
    const limit = 6;
    const navigate = useNavigate();
    const location = useLocation();
    const { comId } = location.state || {};
    const { setLoadingScreen, setNavComValue } = useAuthContext();

    const [pgNo, setPgNo] = useState(1);
    const [searchWord, setSearchWord] = useState("");
    const [searchType, setSearchType] = useState(ddArr[0].value);
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const { isLoading: isProdLoading, isError: isProdErr, error: prodErr, data: prodData } = useQuery([QueryKey.amtcProd, pgNo, isSrchBtnClick],
        () => getProdsNotInCatServ({ comId, pageNumber: pgNo, searchKeyWord: searchWord, searchKeyType: searchType, limit }), {
        enabled: isNotEmpty(comId),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });
    const [selProds, setSelProds] = useState([])

    useEffect(() => {
        if (!comId)
            navigate("/", { replace: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comId])

    useEffect(() => {
        setNavComValue({ comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);

    useEffect(() => {
        setLoadingScreen(isProdLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProdLoading]);

    const handlePageChange = async (event, value) => {
        setPgNo(value)
    };

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setPgNo(1)
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
    }

    function handleDDChange(e) {
        setSearchType(e.target.value)
    }

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setPgNo(1)
        setSearchType("")
    }

    function handleAddProdClick(i) {
        setSelProds((prevSelProds) => {
            // Add the product only if it doesn't already exist
            if (!prevSelProds.some((p) => p.amtcProdIdStrg === i.amtcProdIdStrg)) {
                return [...prevSelProds, i];
            }
            return prevSelProds;
        });
    }

    function handleRmvProdClick(i) {
        setSelProds((prevSelProds) =>
            prevSelProds.filter((p) => p.amtcProdIdStrg !== i.amtcProdIdStrg)
        );
    }

    function handleContinueClick() {
        if (selProds.length === 0) {
            notify("info", "Please select at least one product!")
        } else
            navigate(route.aAddprodtocatDetails, { state: { comId, selProds }, replace: true })
    }


    if (isProdErr) {
        customAlert(prodErr);
        return <h2>Something went wrong</h2>
    }

    return (<Box height={"100%"} width={"100%"}>
        <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
            <BackButton width={"20%"} />
            <Stack direction={"row"} alignItems={'center'} justifyContent={'center'} width={"60%"}>
                <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Add Product To Company Catalog</Typography>
            </Stack>
            <Box width={"20%"} />
        </Stack>
        <BgBoxOld width={"100%"} height={"93%"} py={0.01} px={0.01}>
            <Stack direction={"row"} width={"100%"} height={"100%"}>
                <Stack width={"49%"} >
                    <Stack width={"100%"} alignItems={"center"}>
                        <Typography sx={{ fontSize: 15, fontWeight: 500, my: 1 }}> Select Product </Typography>
                        <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} mb={1} >
                            <Box mb={0.5}><SearchTxtField handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord}
                                onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={`Search Product By ${getSrchTypeTxt(ddArr, searchType)} .....`} /></Box>
                            <CustomDropDown height={30} width={140} handleDDChange={handleDDChange} ddArr={ddArr} defaultValue={ddArr[0].value} />
                        </Stack>
                    </Stack>
                    <ScrollBox height={"78%"}>
                        <Grid container spacing={2}
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {(prodData?.prodsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                                <ProdCardBtn i={i} key={i?.id} mt={0} icon={<AddCircle sx={{ color: "blue" }} />} handleProdClick={handleAddProdClick} /> </Grid>)}
                        </Grid>
                    </ScrollBox>
                    <Stack sx={{ alignItems: "center", mt: 0.5 }}>
                        <Pagination count={Math.ceil(prodData?.totalProdsCount / limit) || 0} color="primary"
                            page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
                    </Stack>
                </Stack>
                <Divider orientation="vertical" flexItem sx={{ height: "100%" }} />
                <Stack width={"49%"} height={"100%"} >
                    <Stack width={"100%"} alignItems={"center"}>
                        <Typography sx={{ fontSize: 15, fontWeight: 500, my: 1 }}> Selected Product </Typography>
                    </Stack>
                    <ScrollBox height={"90%"} >
                        <Grid container spacing={2}
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {selProds.map((i) => <Grid item xs="auto" key={i.id}>
                                <ProdCardBtn i={i} key={i?.id} mt={0} icon={<RemoveCircle color='error' />} handleProdClick={handleRmvProdClick} /> </Grid>)}
                        </Grid>
                    </ScrollBox>
                    <Stack alignItems={"end"}>
                        <Button variant='contained' onClick={handleContinueClick} sx={{
                            '&:hover': { bgcolor: 'rgba(234, 179, 8, 0.9)' },
                            color: 'rgb(30, 64, 175)', bgcolor: 'rgba(255, 183, 3, 1)', height: 30, mb: 2, mr: 1
                        }}>
                            CONTINUE</Button>
                    </Stack>

                </Stack>
            </Stack>
        </BgBoxOld>
    </Box>
    )
}
export default AddProdToCompCatalog;